package top.wcpe.allincore.dsl.compiler.api

import top.wcpe.allincore.dsl.compiler.type.IrType

/**
 * 跨文件类型表（M10 Stage 3 引入）。
 *
 * 由 IDE 端从 stub index 收集，承载项目内所有 data 类字段与 fun 签名信息，
 * 供 TypeInferencer 在解析 LocalRef / MemberAccess 时跨文件反查精确类型。
 *
 * @property dataFields 类名 → 字段名 → 字段类型
 * @property functions 函数名 → 函数签名
 */
data class ProjectTypeTable(
    val dataFields: Map<String, Map<String, IrType>>,
    val functions: Map<String, FunSignature>,
) {
    companion object {
        /** 空表常量；旧 2 参 inferExpr / analyzeTypes 内部委托新签名时使用。 */
        val EMPTY: ProjectTypeTable = ProjectTypeTable(
            dataFields = emptyMap(),
            functions = emptyMap(),
        )

        /**
         * 从 IDE 端的字符串表构造。
         *
         * @param dataFieldStrings 类名 → 字段名 → TypeAst raw 文本
         * @param functionStrings 函数名 → (paramType raw 文本列表, returnType raw 文本)
         */
        fun fromStrings(
            dataFieldStrings: Map<String, Map<String, String?>>,
            functionStrings: Map<String, FunSignatureStrings>,
        ): ProjectTypeTable = ProjectTypeTable(
            dataFields = dataFieldStrings.mapValues { (_, fields) ->
                fields.mapValues { (_, raw) -> TypeStringParser.parse(raw) }
            },
            functions = functionStrings.mapValues { (_, sig) ->
                FunSignature(
                    paramTypes = sig.paramTypeRaws.map { TypeStringParser.parse(it) },
                    returnType = TypeStringParser.parse(sig.returnTypeRaw),
                )
            },
        )
    }
}

/** 函数签名：参数类型与返回类型。 */
data class FunSignature(
    val paramTypes: List<IrType>,
    val returnType: IrType,
)

/** IDE 端用，承载 fun 签名的字符串表示。 */
data class FunSignatureStrings(
    val paramTypeRaws: List<String?>,
    val returnTypeRaw: String?,
)
